export interface DesktopClient {
  constants?: {
    BROWSER_ONLY_PATH_PREFIXES?: string[];
  };
  platform?: string;

  version?: number;
  isHomeTab?: boolean;

  logout?: () => void;

  loadURL?: (url: string) => void;
  openExternalURL?: (url: string) => void;

  addTab?: (url?: string) => void;
  addInitialTab?: (url?: string) => void;
  closeTab?: (id: number) => void;
  forwardInTab?: (id: number, newTab?: boolean) => void;
  backInTab?: (id: number, newTab?: boolean) => void;
  focusTab?: (id: number) => void;
  focusOrRestoreTab?: (id: number) => void;
  onTabChange?: (handler: (state: TabBarState) => void) => void;
  moveTab?: (sourceIndex: number, destinationIndex: number) => void;
  openTabContextMenu?: (id: number) => void;
  reloadAllTabs?: () => () => void;
  setDesktopTabIcon?: (iconUrl: string) => void;
  setDesktopTabTitle?: (title: string) => void;
  setIsTabBarMenuOpen?: (forceValue?: boolean) => void;

  onIframeBlock?: (name: string, handler: () => void) => () => void;
  toggleTitleBarMenu?: () => void;

  changeTheme?: (theme: string) => void;
  onThemeChange?: (handler: (theme: string) => void) => void;

  onFeatureRequested?: <T = unknown>(
    feature: string,
    handler: (payload: T) => void,
  ) => () => void;
  startSession?: (userType: string) => void;
}

declare global {
  interface Window {
    desktop?: DesktopClient;
  }
}

export type TabItem = {
  id: number;
  title: string;
  focusedTime: number;
  icon: string;
  iconUrl: string;
  url: string;
};

export type TabBarState = {
  tabs: TabItem[];
  focusedTabId: number;
  canGoForward: boolean;
  canGoBack: boolean;
  homeTabId?: number;
  isTabBarMenuOpen: boolean;
};

export const DesktopPlatforms = {
  mac: 'darwin',
  windows: 'win32',
};

export const isElectron = Boolean(
  typeof window !== 'undefined' && window.desktop,
);
